import * as React from 'react';

import { Aspect, Image } from './FixedAspectImage.styles';
import { getCloudinaryUrl } from '../../services/cloudinary';
import { IFixedAspectImageProps } from '../../../src/models/content.interfaces';

export const FixedAspectImage = ({ imageSHA, alt }: IFixedAspectImageProps) => {
  return (
    <Aspect>
      <Image data-id="fixed-aspect-image" src={getCloudinaryUrl(imageSHA)} alt={alt} />
    </Aspect>
  );
};
